import useStyles from 'isomorphic-style-loader/useStyles';
import type { ReactNode } from 'react';
import { useDebounceValue } from 'usehooks-ts';

import { ComponentLoader } from '@components/component-loader';

import s from './load-more-footer.scss';

const DEBOUNCE_MS = 400;

// Hoisted: a fresh literal rebuilds the debounce instance, defeating it.
const DEBOUNCE_OPTIONS = { leading: true };

export interface LoadMoreFooterProps {
  /**
   * Whether a fetch for more items is in flight.
   */
  isLoading: boolean;
  /**
   * Message shown beside the spinner.
   */
  message?: ReactNode;
}

/**
 * Spinner shown beneath an incrementally-loaded list while the next page is
 * fetched, held briefly so a fast fetch doesn't flash it.
 */
export const LoadMoreFooter = ({ isLoading, message }: LoadMoreFooterProps) => {
  useStyles(s);

  const [debouncedIsLoading] = useDebounceValue(
    isLoading,
    DEBOUNCE_MS,
    DEBOUNCE_OPTIONS,
  );

  if (!debouncedIsLoading) return null;

  return (
    <ComponentLoader
      className={s.loader}
      inline="centered"
      content={message}
      active
    />
  );
};

export default LoadMoreFooter;
